import { masterTypeQueryOptions } from '@/shared/queries/master-data.query'
import { MasterTypeListResponse } from '@/shared/types/master-data'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { t } from 'i18next'

const loader = async ({ context }: any) => {
    const masterType: MasterTypeListResponse = await context.queryClient.ensureQueryData(masterTypeQueryOptions())
    const dynamicPath =
        masterType?.data?.map(item => {
            const code = item.code.toLowerCase()
            return {
                to: `/categories/${code}`,
                label: item.name,
                code,
                masterTypeId: item.id,
            }
        }) || []

    const functionalDepartmentLink = dynamicPath.find(item => item.code === 'functional_department')
    const otherDynamicPaths = dynamicPath.filter(item => item.code !== 'functional_department')

    const links = [
        { to: '/categories/departments', label: t('tabs.departments'), code: 'departments', masterTypeId: '1' },
        { to: '/categories/regions', label: t('tabs.regions'), code: 'regions', masterTypeId: '2' },
        ...(functionalDepartmentLink ? [functionalDepartmentLink] : []),
        { to: '/categories/areas', label: t('tabs.areas'), code: 'areas', masterTypeId: '3' },
        ...otherDynamicPaths,
    ]

    return { links }
}

export const Route = createFileRoute('/categories/_pathlessLayout')({
    loader,
    component: RouteComponent,
})

function RouteComponent() {
    return <Outlet />
}
